import * as React from 'react';
import { IconActionChevronLeft16 } from '@cian/ui-kit-design-tokens/icons';
import { debounce } from 'throttle-debounce';

import * as style from './PrevButton.css';
import { TABLE_SCROLL_BUTTON_DELAY } from '../../constants/delays';

export interface IPrevButtonProps {
  first: boolean;
  onClick: () => void;
}

export const PrevButton = ({ first, onClick }: IPrevButtonProps) => {
  // oxlint-disable-next-line react/exhaustive-deps
  const debouncedHandleClick = React.useCallback(debounce(TABLE_SCROLL_BUTTON_DELAY, onClick), [onClick]);

  if (first) {
    return null;
  }

  return (
    <div onClick={debouncedHandleClick} className={style['container']}>
      <IconActionChevronLeft16 color={'icon-inverted-default'} />
    </div>
  );
};
